export default "__VITE_ASSET__D4HzWJ2f__"